// ENTITY fr.gestionpial.pial.entities.Notification generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { TypeNotification } from './TypeNotification';

export class Notification {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.entities.Notification';

  idNotification: number | null = 0;
  idClasse: number | null = 0;
  idPial: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  typeNotification: TypeNotification | null = null;
  volumeHoraireHebdo: number | null = 0;
  dateDebut: Date | null = null;
  dateFin: Date | null = null;
  idNotificationPrecedente: number | null = null;
  del: boolean | null = false;

  constructor(init?:Partial<Notification>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.entities.Notification'] = Notification;

fields['fr.gestionpial.pial.entities.Notification']  = {
    idNotification: 'java.lang.Integer',
    idClasse: 'java.lang.Integer',
    idPial: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    typeNotification: 'fr.gestionpial.pial.entities.TypeNotification',
    volumeHoraireHebdo: 'java.lang.Integer',
    dateDebut: 'java.time.LocalDate',
    dateFin: 'java.time.LocalDate',
    idNotificationPrecedente: 'java.lang.Integer',
    del: 'java.lang.Boolean'
};
